const workshopFeaturesJa = {
  // ポリッシャー（pol-001〜pol-010）
  product_pol_001_feature_1_title: 'LCD 表示と精密変速',
  product_pol_001_feature_1_desc: '高精細 LCD ディスプレイを搭載し、回転数をリアルタイムで表示。2000-4500/min の多段階精密変速に対応し、素材や研磨段階に合わせた直感的な操作が可能です。',
  product_pol_001_feature_2_title: '定電力とソフトスタート技術',
  product_pol_001_feature_2_desc: 'インテリジェントチップによる定電力補正機能を内蔵し、高負荷時でも回転数を一定に維持。ソフトスタート機能によりコンパウンドの飛散を防ぎ、完璧で繊細な仕上がりを実現します。',
  product_pol_001_feature_3_title: '8mm 偏心オービット設計',
  product_pol_001_feature_3_desc: '8mm (0.32") の偏心振幅設計を採用。このデュアルアクション軌道運動により、オーロラマークや塗装の焼き付きを効果的に防ぎ、研磨効率と安全性を大幅に高めます。',
  product_pol_001_feature_4_title: 'プロ仕様 150mm 大径パッド',
  product_pol_001_feature_4_desc: 'Ø150mm (5.9") のポリッシングパッドに対応。一度の作業で広範囲をカバーでき、車体、大理石、家具表面の大面積な修復や鏡面仕上げに最適です。',
  product_pol_001_feature_5_title: '人間工学に基づいたロングハンドル設計',
  product_pol_001_feature_5_desc: '1.6kg のバランスの取れたボディとスリムなロングハンドル設計により、柔軟な操作が可能。長時間の作業でも疲労を大幅に軽減し、プロ級の快適な操作感を提供します。',

  product_pol_002_feature_1_title: '150mmロータリーポリッシャー',
  product_pol_002_feature_1_desc: '150mmロータリーポリッシャーでプロの車体修理仕上げのための高速塗装切削とコンパウンド塗布を実現します。',
  product_pol_002_feature_2_title: '600〜3200RPMロータリー速度',
  product_pol_002_feature_2_desc: '600〜3200RPMの可変ロータリー速度でコンパウンド切削から最終光沢仕上げまでの完全範囲をカバーします。',
  product_pol_002_feature_3_title: '750W切削パワーモーター',
  product_pol_002_feature_3_desc: '750Wモーターで傷や酸化した塗装への積極的なコンパウンド切削に必要な高トルクを提供します。',
  product_pol_002_feature_4_title: '2.3kg安定ロータリーボディ',
  product_pol_002_feature_4_desc: '2.3kgの本体重量でロータリー切削中のパネル表面への一定なコンパウンド圧力を維持するのに役立ちます。',
  product_pol_002_feature_5_title: '5.0N·m切削トルク',
  product_pol_002_feature_5_desc: '5.0N·mのトルク出力でコンパウンドの抵抗下でロータリーが減速するのを防ぎ、均一な塗装切削を実現します。',

  product_pol_003_feature_1_title: '125mmコンパクト軌道ポリッシャー',
  product_pol_003_feature_1_desc: '125mmの軌道パッドでドアジャンブ、バンパーエンド、Aピラーなど大きなパッドが届かない狭い場所を磨きます。',
  product_pol_003_feature_2_title: '2500〜7800 OPM精細磨き速度',
  product_pol_003_feature_2_desc: '高い最大7800 OPMでスワールマークを完全に除去する最終仕上げ磨きに必要な速度を提供します。',
  product_pol_003_feature_3_title: '350Wコンパクト磨きモーター',
  product_pol_003_feature_3_desc: '350Wコンパクト ACモーターで狭いパネル断面の小さな125mmパッドを効率的に過熱なく動かします。',
  product_pol_003_feature_4_title: '1.6kg片手磨き',
  product_pol_003_feature_4_desc: '1.6kgで小さなパネルや狭いディテールエリアの片手磨きに十分な軽さです。',
  product_pol_003_feature_5_title: '2.5N·mディテールトルク',
  product_pol_003_feature_5_desc: '2.5N·mのトルクは繊細なクリアコートを焼く危険なく小さなエリアの仕上げ磨きに最適化されています。',

  product_pol_004_feature_1_title: '200mm大型ポリッシャー',
  product_pol_004_feature_1_desc: '200mmの大型パッドでボンネット、ルーフ、ドアなどの平らなボディパネルをはるかに少ないパスで処理します。',
  product_pol_004_feature_2_title: '2000〜6200 OPM広速度範囲',
  product_pol_004_feature_2_desc: '2000〜6200 OPMで低速での軽いワックスがけから高速での積極的なコンパウンド作業まですべてをカバーします。',
  product_pol_004_feature_3_title: '650W大型パッドモーター',
  product_pol_004_feature_3_desc: '650W ACモーターで長い平面パネル磨きセッション全体を通じて大型200mmパッドの高い負荷を維持します。',
  product_pol_004_feature_4_title: '2.5kgプロボディ重量',
  product_pol_004_feature_4_desc: '2.5kgの本体重量で水平表面全体の大型200mmパッドへの正確なダウンフォースを提供します。',
  product_pol_004_feature_5_title: '4.5N·m高パッドトルク',
  product_pol_004_feature_5_desc: '4.5N·mのトルクでコンパウンドの抵抗下で大型200mmパッドが減速するのを防ぎます。',

  product_pol_005_feature_1_title: '180mm家具ポリッシャー',
  product_pol_005_feature_1_desc: '180mmの軌道ポリッシャーで家具へのワックスがけ、ニス仕上げ、木質表面の高光沢へのバフがけに使用します。',
  product_pol_005_feature_2_title: '1500〜6800 OPM家具速度',
  product_pol_005_feature_2_desc: '低い1500 OPMの開始速度で家具表面への初回磨き剤塗布時の木ニス筋の防止を実現します。',
  product_pol_005_feature_3_title: '500W木質磨きモーター',
  product_pol_005_feature_3_desc: '500W ACモーターで繊細な木質仕上げを過熱せずに家具磨きに適したパワーバランスを提供します。',
  product_pol_005_feature_4_title: '2.1kgバランス家具ツール',
  product_pol_005_feature_4_desc: '2.1kgのバランスされた重量で家具パネルや曲線木質表面全体での均一な接触を維持します。',
  product_pol_005_feature_5_title: '24ヶ月保証',
  product_pol_005_feature_5_desc: '2年包括保証でプロ家具仕上げワークショップを予期しないツール故障から保護します。',

  product_pol_006_feature_1_title: '150mm中型仕上げポリッシャー',
  product_pol_006_feature_1_desc: '150mmパッドがコンパクトなディテールポリッシャーと大型平面パネルマシンの間を埋め、多用途な仕上げを実現します。',
  product_pol_006_feature_2_title: '1500〜6500 OPM精密コントロール',
  product_pol_006_feature_2_desc: '1500〜6500 OPMのスムーズな線形速度コントロールでカット、磨き、仕上げ段階の間の段階的な移行が可能です。',
  product_pol_006_feature_3_title: '600W中型モーター',
  product_pol_006_feature_3_desc: '600Wモーターが一定の出力でコンパウンド、磨き剤、ワックスをカバーする150mmパッドを処理します。',
  product_pol_006_feature_4_title: '2.2kg中型バランス',
  product_pol_006_feature_4_desc: '2.2kgの中型ウェイトでドアや後輪フェンダーパネルなどの垂直パネル作業で快適に使用できます。',
  product_pol_006_feature_5_title: '4.0N·m中型トルク出力',
  product_pol_006_feature_5_desc: '4.0N·mのトルクで中型コンパウンド切削と最終仕上げを同等の効果で処理します。',

  product_pol_007_feature_1_title: '125mmコードレス軌道ポリッシャー',
  product_pol_007_feature_1_desc: '20Vコードレス125mmポリッシャーでワークショップのどこでも、または電源コンセントなしの屋外イベントでも作業可能です。',
  product_pol_007_feature_2_title: '2500〜7800 OPMコードレス速度',
  product_pol_007_feature_2_desc: 'フル2500〜7800 OPMがコードレスで利用可能、バッテリー形式でも磨きパフォーマンスに妥協なしです。',
  product_pol_007_feature_3_title: '20Vバッテリープラットフォーム自由',
  product_pol_007_feature_3_desc: '20Vバッテリープラットフォームと互換性があり、他のツールとバッテリーを共有し柔軟なショップ整理が可能です。',
  product_pol_007_feature_4_title: '1.8kgコードレス便利さ',
  product_pol_007_feature_4_desc: 'バッテリー込み1.8kgでほとんどの有線ポリッシャーより軽く、ディテールエリアへの片手操作が可能です。',
  product_pol_007_feature_5_title: '350W効率的コードレスモーター',
  product_pol_007_feature_5_desc: '350Wブラシレスモーターでバッテリー効率を最大化し、有刷代替品より1回の充電でより多くの磨き時間を提供します。',

  product_pol_008_feature_1_title: '空気圧180mmエアポリッシャー',
  product_pol_008_feature_1_desc: 'エア駆動180mmポリッシャーはシリーズ最軽量の1.9kgで、圧縮空気を持つ量産車体工場に最適です。',
  product_pol_008_feature_2_title: '0.63MPaエア駆動動作',
  product_pol_008_feature_2_desc: '標準0.63MPaのショップエアで駆動し、ノンストップ動作のためにコンプレッサーマニホールドに直接接続します。',
  product_pol_008_feature_3_title: '75dB最静音ポリッシャー',
  product_pol_008_feature_3_desc: '≦75dBはシリーズ最静音で、空気圧動作が本質的に電気モーターよりも少ないノイズを生成します。',
  product_pol_008_feature_4_title: '1.9kgの最軽量プロポリッシャー',
  product_pol_008_feature_4_desc: '1.9kgはポリッシャーシリーズ最軽量の本体で、大量の車体工場量産中の腕疲労を軽減します。',
  product_pol_008_feature_5_title: 'バッテリーや電源ケーブル不要',
  product_pol_008_feature_5_desc: '空気圧設計でバッテリーと電源ケーブルを排除し、エアホースをつないで継続的に磨けます。',

  product_pol_009_feature_1_title: '150mmディテールショップポリッシャー',
  product_pol_009_feature_1_desc: '150mmポリッシャーがプロのディテールショップ向けに最適化され、1本のツールでコンパウンドから最終ワックスまでのすべての段階を処理します。',
  product_pol_009_feature_2_title: '2500〜6800 OPMショップ速度範囲',
  product_pol_009_feature_2_desc: '2500〜6800 OPMでカットコンパウンドから仕上げワックスまでの完全なプロディテーリングプロセスをカバーします。',
  product_pol_009_feature_3_title: '500W信頼性の高いワークショップモーター',
  product_pol_009_feature_3_desc: '500Wモーターで毎日複数の車を磨くディテーリングプロに信頼性の高い一定のパフォーマンスを提供します。',
  product_pol_009_feature_4_title: '2.0kg効率的なショップ重量',
  product_pol_009_feature_4_desc: '2.0kgは毎日複数の車で作業するディテーラーに管理可能で、累積的な腕疲労を軽減します。',
  product_pol_009_feature_5_title: '3.5N·mバランストルク',
  product_pol_009_feature_5_desc: '3.5N·mのバランスされたトルク出力がコンパウンド、磨き剤、保護コーティング塗布に同等に機能します。',

  product_pol_010_feature_1_title: '180mmプロスタジオポリッシャー',
  product_pol_010_feature_1_desc: '180mmプロスタジオポリッシャーでハイエンドのディテーリング、コンクール準備、高級車仕上げに対応します。',
  product_pol_010_feature_2_title: '2500〜6800 OPMプレミアム速度',
  product_pol_010_feature_2_desc: '2500〜6800 OPMのプレミアム範囲でプロレベルの塗装修正と保護作業のすべての段階を処理します。',
  product_pol_010_feature_3_title: '500W持続プレミアムパワー',
  product_pol_010_feature_3_desc: '500W ACモーターで高価値の車への均一な表面仕上げ品質のための一定のパッド速度を維持します。',
  product_pol_010_feature_4_title: '2.2kgプロボディ',
  product_pol_010_feature_4_desc: '2.2kgの慎重にバランスされたプロ本体で曲線パネル表面への一定のパッド圧力を確保します。',
  product_pol_010_feature_5_title: '24ヶ月ワークショップ保証',
  product_pol_010_feature_5_desc: '2年保証で毎日集中的なツール使用での高量産プロディテーリング作業をサポートします。',

  // サンダー（san-001〜san-010）
  product_san_001_feature_1_title: '125mmランダム軌道サンダー',
  product_san_001_feature_1_desc: '125mmのランダム軌道動作で木材、金属、フィラー表面へのスワールフリーサンディングを実現します。',
  product_san_001_feature_2_title: '4000〜12000 OPMサンディング速度',
  product_san_001_feature_2_desc: '4000〜12000 OPMの可変速度で積極的な材料除去から精細な仕上げサンディングまでのすべてに対応します。',
  product_san_001_feature_3_title: '350W効率的サンディングモーター',
  product_san_001_feature_3_desc: '350Wモーターで一定の材料除去率で車体フィラー、塗料層、木質表面を処理します。',
  product_san_001_feature_4_title: '1.4kg軽量サンダー',
  product_san_001_feature_4_desc: '1.4kgで頭上サンディングや長時間の継続使用でも疲労なく十分な軽さです。',
  product_san_001_feature_5_title: '集塵ポート',
  product_san_001_feature_5_desc: '統合集塵ポートでワークショップの掃除機に接続し、クリーンで低粉塵のサンディング環境を実現します。',

  product_san_002_feature_1_title: '150mm大面積軌道サンダー',
  product_san_002_feature_1_desc: '150mmサンディングパッドで125mmサンダーより44%多い面積をパスごとにカバーし、大きな表面作業を大幅に高速化します。',
  product_san_002_feature_2_title: '4000〜12000 OPM可変範囲',
  product_san_002_feature_2_desc: '150mmパッドでの4000〜12000 OPMが積極的な塗料剥がしと超精細仕上げサンディングの両方を処理します。',
  product_san_002_feature_3_title: '380W大ディスクモーター',
  product_san_002_feature_3_desc: '380Wモーターで大きな150mmサンディングディスクの増加した負荷の下でも速度を維持し一定の結果を提供します。',
  product_san_002_feature_4_title: '1.6kg大パッドバランス',
  product_san_002_feature_4_desc: '1.6kgのバランスされた重量でより大きな150mmパッド表面全体に均一なサンディング圧力を提供します。',
  product_san_002_feature_5_title: '76dB低ノイズ動作',
  product_san_002_feature_5_desc: '≦76dBでこの大きな軌道サンダーをワークショップ使用のクラスで最も静かなものの一つにします。',

  product_san_003_feature_1_title: '93mm三角形ディテールサンダー',
  product_san_003_feature_1_desc: '三角形93mmパッドでコーナー、キャビネット継ぎ目内部、丸いサンダーがアクセスできないディテールエリアに届きます。',
  product_san_003_feature_2_title: '8000〜20000 OPM高速ディテール',
  product_san_003_feature_2_desc: '最高20000 OPMの高速度で詰まらずに狭いコーナーの精密なディテールサンディングを実現します。',
  product_san_003_feature_3_title: '250Wコンパクトコーナーモーター',
  product_san_003_feature_3_desc: '250Wモーターで小さな三角形パッドに継ぎ目、コーナー、成形表面の速くクリーンなサンディングのためのパワーを供給します。',
  product_san_003_feature_4_title: '1.1kg超軽量ディテールツール',
  product_san_003_feature_4_desc: 'わずか1.1kgでこれは最軽量サンダーで、家具や廻り縁の終日細かいディテールサンディングに最適です。',
  product_san_003_feature_5_title: '三点サンディングジオメトリ',
  product_san_003_feature_5_desc: '三角形ジオメトリで1回のパスで内側コーナーとプロファイル廻り縁の3つの側面すべてに届きます。',

  product_san_004_feature_1_title: '200×75mmベルトサンダー',
  product_san_004_feature_1_desc: '200×75mmのベルトを持つベルトサンダーで粗い木質表面の均し用に軌道サンダーより速い材料除去を実現します。',
  product_san_004_feature_2_title: '0〜3m/s可変ベルト速度',
  product_san_004_feature_2_desc: '0〜3m/sの可変ベルト速度で穏やかから積極的なサンディングまで材料除去率を調整できます。',
  product_san_004_feature_3_title: '500W積極的除去モーター',
  product_san_004_feature_3_desc: '500Wモーターで粗鋸切り木材、重い塗料、硬木フロアへの積極的な素材除去を処理します。',
  product_san_004_feature_4_title: '2.8kgベルトサンダー安定性',
  product_san_004_feature_4_desc: '2.8kgの本体重量で平坦で均一な材料除去のための一定のベルト接触圧力を維持するのに役立ちます。',
  product_san_004_feature_5_title: 'クイックチェンジベルトシステム',
  product_san_004_feature_5_desc: 'ツール不要のベルト交換システムでレンチや手動ベルト追跡調整なしに数秒でサンディングベルトを交換できます。',

  product_san_005_feature_1_title: '125mmアンチスワールサンダー',
  product_san_005_feature_1_desc: 'アンチスワール軌道機構で硬木家具や塗装パネルへのよりクリーンで精細な表面を実現します。',
  product_san_005_feature_2_title: '4000〜12000 OPM仕上げ品質',
  product_san_005_feature_2_desc: '4000〜12000 OPMの範囲で同じツールで素早い素材除去とガラスのように滑らかな仕上げを実現します。',
  product_san_005_feature_3_title: '350W信頼性の高い仕上げモーター',
  product_san_005_feature_3_desc: '350Wモーターで手サンディング作業の変化する圧力下でも一定のパッド速度を維持します。',
  product_san_005_feature_4_title: '1.4kg家具仕上げ重量',
  product_san_005_feature_4_desc: '軽量1.4kgで腕疲労がサンディング品質を低下させる長時間の家具仕上げセッションに最適です。',
  product_san_005_feature_5_title: 'ベルクロフック・ループパッドシステム',
  product_san_005_feature_5_desc: 'ベルクロ取り付けシステムでツール不要の迅速な粒度変更が可能で、80番から400番に数秒で切り替えられます。',

  product_san_006_feature_1_title: '150mmプロ仕上げサンダー',
  product_san_006_feature_1_desc: '150mmのプロサンダーが家具メーカーに要求される大面積カバレッジと表面品質を提供します。',
  product_san_006_feature_2_title: '4000〜12000 OPMプロ仕上げ速度',
  product_san_006_feature_2_desc: '最大12000 OPMの全可変速度でプロメーカーに要求される精細で均一な仕上げ表面品質を提供します。',
  product_san_006_feature_3_title: '380Wプロサンディングモーター',
  product_san_006_feature_3_desc: '380W ACモーターで厚い木質仕上げ除去と精細な木目準備を通じて150mmパッド速度を維持します。',
  product_san_006_feature_4_title: '1.6kgプロバランス',
  product_san_006_feature_4_desc: '1.6kgのプロウェイトで精細な家具仕上げ作業に必要な制御された手圧力を提供します。',
  product_san_006_feature_5_title: '76dBワークショップフレンドリーノイズ',
  product_san_006_feature_5_desc: '≦76dBでこの150mmサンダーをノイズ管理要件のあるワークショップに適したものにします。',

  product_san_007_feature_1_title: '125mm 20Vコードレスサンダー',
  product_san_007_feature_1_desc: '電源ケーブルなしの現場木工、リノベーション、塗装準備のためのコードレス20V軌道サンダーです。',
  product_san_007_feature_2_title: '4000〜12000 OPMコードレス速度',
  product_san_007_feature_2_desc: 'バッテリーパワーで全12000 OPMが利用可能、電源なしで作業する際にパフォーマンス妥協なし。',
  product_san_007_feature_3_title: '20Vバッテリープラットフォーム',
  product_san_007_feature_3_desc: '20Vバッテリー互換性で他のコードレスツールとのパワー共有が可能、1つのバッテリーで複数のツール。',
  product_san_007_feature_4_title: '1.5kgコードレスポータビリティ',
  product_san_007_feature_4_desc: 'バッテリー込み1.5kgで延長コードなしに現場のどこでも快適なポータブルサンディングが可能です。',
  product_san_007_feature_5_title: '350W効率的ブラシレスモーター',
  product_san_007_feature_5_desc: 'ブラシレス350Wモーターでバッテリーランタイムを延ばし、長時間のコードレスサンディング中の発熱を抑えます。',

  product_san_008_feature_1_title: '100mm空気圧ディテールサンダー',
  product_san_008_feature_1_desc: '100mmの空気圧サンダーは最軽量の0.9kgで、継続的な空気供給での生産ライン向けディテールサンディングに最適です。',
  product_san_008_feature_2_title: '0.63MPaエア駆動動作',
  product_san_008_feature_2_desc: '圧縮空気で駆動し、継続的な空気供給を持つ生産ラインでのノンストップサンディング動作を提供します。',
  product_san_008_feature_3_title: '0.9kg超軽量空気圧ボディ',
  product_san_008_feature_3_desc: '0.9kgは利用可能な最軽量サンダーで、高い日産量の生産ラインでのオペレーター疲労を軽減します。',
  product_san_008_feature_4_title: '70dB静音空気圧サンディング',
  product_san_008_feature_4_desc: '≦70dBはシリーズ最静音で、空気圧サンディングでワークショップのノイズレベルを大幅に低減します。',
  product_san_008_feature_5_title: 'バッテリーやコード不要',
  product_san_008_feature_5_desc: '空気圧設計でバッテリーとコード管理をすべて排除し、最もクリーンで生産性の高いワークフローを実現します。',

  product_san_009_feature_1_title: '225mm長リーチ壁サンダー',
  product_san_009_feature_1_desc: '225mmの大型パッドで床レベルから石膏、石膏ボード、天井表面をサンディングし、足場と脚立の使用を排除します。',
  product_san_009_feature_2_title: '200〜650RPM壁サンディング速度',
  product_san_009_feature_2_desc: 'ゆっくりとした200〜650RPMの範囲で効果的な表面準備を提供しながら石膏ボードコンパウンドの傷つきを防ぎます。',
  product_san_009_feature_3_title: '750W壁サンディングモーター',
  product_san_009_feature_3_desc: '750Wモーターで詰まることなくテクスチャのある壁表面でも石膏と石膏ボードを通じて225mmパッドを押し通します。',
  product_san_009_feature_4_title: '3.2kg長リーチ安定性',
  product_san_009_feature_4_desc: '3.2kgの本体重量と長いハンドルの組み合わせで一定の石膏ボード表面準備に必要な安定性を提供します。',
  product_san_009_feature_5_title: '伸縮ハンドルシステム',
  product_san_009_feature_5_desc: '延伸ハンドルで脚立なしに床から天井まで届き、石膏ボード業者の最大生産性を実現します。',

  product_san_010_feature_1_title: '125mm経済的ワークショップサンダー',
  product_san_010_feature_1_desc: '毎日のワークショップ使用のための信頼性の高い125mm軌道サンダーで塗料除去、木材準備、最終仕上げを処理します。',
  product_san_010_feature_2_title: '4000〜12000 OPMワークショップ範囲',
  product_san_010_feature_2_desc: '全12000 OPM可変速度範囲でストリップから仕上げまでのすべての一般的なワークショップサンディングタスクをカバーします。',
  product_san_010_feature_3_title: '70dB超低ノイズ',
  product_san_010_feature_3_desc: '≦70dBは125mmサンダーカテゴリで最低ノイズ、居住エリア近くのホームワークショップに最適です。',
  product_san_010_feature_4_title: '1.4kg経済的ワーキング',
  product_san_010_feature_4_desc: '1.4kgの軽量本体で実用的な毎日サンダーが必要な趣味人やDIYユーザーに優れたコストパフォーマンスを提供します。',
  product_san_010_feature_5_title: '350W信頼性の高い経済的モーター',
  product_san_010_feature_5_desc: '350Wモーターで毎日のDIYと軽いプロワークショップのタスクに一定のパフォーマンスを提供します。',

  // ホットグルーガン（glue-001〜glue-010）
  product_glue_001_feature_1_title: '超高速予熱とスタートアップ',
  product_glue_001_feature_1_desc: '高度な MCH セラミック加熱技術を採用し、2秒のクイックスタートと15秒の超高速予熱を実現。作業の待ち時間を大幅に短縮します。',
  product_glue_001_feature_2_title: 'インテリジェントな安全保護',
  product_glue_001_feature_2_desc: '5分間のオートオフ機能を搭載し、電力の無駄遣いや安全上のリスクを防止。また、残量確認ウィンドウによりグルースティックの消費状況を一目で把握できます。',
  product_glue_001_feature_3_title: '精密でスムーズな操作性',
  product_glue_001_feature_3_desc: 'トリガーフィード設計と 1.3mm の微細な吐出口により、安定したグルーの供給を実現。繊細な接着作業もスムーズに行えます。',
  product_glue_001_feature_4_title: '便利な USB Type-C 充電',
  product_glue_001_feature_4_desc: '汎用性の高い USB Type-C 充電ポートを採用。モバイルバッテリーやアダプターを使って、場所を選ばず充電が可能です。',
  product_glue_001_feature_5_title: '超軽量エラストマー設計',
  product_glue_001_feature_5_desc: '本体重量はわずか 0.25kg。超軽量設計と内蔵 LED ワークライトにより、狭い場所や暗い環境での作業もストレスなく行えます。',

  product_glue_002_feature_1_title: '工業用 MCH セラミック加熱技術',
  product_glue_002_feature_1_desc: '高性能 MCH 加熱エレメントを搭載。2秒のクイックスタートと15秒の超高速予熱により、スピーディーな作業でも安定したグルー供給が可能です。',
  product_glue_002_feature_2_title: '優れた航続距離と作業能力',
  product_glue_002_feature_2_desc: '12V 2.0Ah バッテリーパックを採用し、1回の充電で40本のグルースティックを使用可能。4Vモデルの2倍の容量で、長時間の重負荷作業にも対応します。',
  product_glue_002_feature_3_title: '精密な制御と可視化設計',
  product_glue_002_feature_3_desc: '1.3mm の微細な吐出口とトリガーフィードシステムを搭載。サイドの確認ウィンドウにより、精密な制御と残量のリアルタイム監視が可能です。',
  product_glue_002_feature_4_title: '万全なインテリジェント安全保護',
  product_glue_002_feature_4_desc: '5分間のオートオフ機能を内蔵し、火傷や電力の無駄を防止。LED ワークライトを装備し、薄暗い環境でも安全に作業できます。',
  product_glue_002_feature_5_title: '堅牢な工業グレード構造',
  product_glue_002_feature_5_desc: '0.45kg のボディはバランスの取れた重量配分を実現。12V スライド式バッテリーベースにより、作業が安定するだけでなく、そのまま自立させることも可能です。',

  product_glue_003_feature_1_title: 'フルオートスマート送りシステム',
  product_glue_003_feature_1_desc: '革新的なフルオート送り・装填システムを搭載。手動の押し込みが不要になり、連続的で精密かつ均一な自動グルー供給を実現します。',
  product_glue_003_feature_2_title: '工業グレードの高効率加熱',
  product_glue_003_feature_2_desc: 'MCH セラミック加熱技術により、わずか 110 秒の予熱で 13g/min の高出力を実現。3mm の大口径ノズルにより、広範囲の重負荷接着作業に最適です。',
  product_glue_003_feature_3_title: '最高クラスの航続距離と作業量',
  product_glue_003_feature_3_desc: '強力な 20V 2.0Ah バッテリーに対応。1回の充電で ∅11 x 200mm の工業用ロングスティック15本を消費可能で、過酷な現場での長時間作業に対応します。',
  product_glue_003_feature_4_title: '多機能スマート監視と保護',
  product_glue_003_feature_4_desc: '5分間のオートオフ保護機能と欠料アラームランプを搭載。内蔵 LED ワークライトとの組み合わせで、あらゆる環境下でも安全かつ効率的な作業を保証します。',
  product_glue_003_feature_5_title: 'プロ仕様の安定構造設計',
  product_glue_003_feature_5_desc: ' 0.36kg の軽量設計と安定した 20V バッテリーベースの組み合わせ。握り心地が良く、作業台に安定して自立できるため、グルー漏れのリスクも軽減します。',

  product_glue_004_feature_1_title: '120Wデュアル温度グルーガン',
  product_glue_004_feature_1_desc: '120Wのガンで選択可能な高低温モードにより熱に敏感な材料と標準材料の両方への接着に柔軟性を提供します。',
  product_glue_004_feature_2_title: '160〜230°C広温度範囲',
  product_glue_004_feature_2_desc: 'シリーズ最広温度範囲で低温フォーム作業から高温構造木材・金属接着まで対応します。',
  product_glue_004_feature_3_title: '14g/分最速グルー出力',
  product_glue_004_feature_3_desc: '14g/分はシリーズ最高のグルー出力量で、高速量産接着や組立作業に最適です。',
  product_glue_004_feature_4_title: '120W最大パワー',
  product_glue_004_feature_4_desc: '120Wは利用可能な最大ワット数で、継続的な高出力使用中の素早い温度回復を提供します。',
  product_glue_004_feature_5_title: 'デュアルモード温度切替',
  product_glue_004_feature_5_desc: '切り替え可能な温度モードでツールを変えずに160°Cクラフトモードと230°C工業モードの間を切り替えられます。',

  product_glue_005_feature_1_title: '80W 20Vコードレスグルーガン',
  product_glue_005_feature_1_desc: '20Vバッテリー駆動のコードレスグルーガンでクラフト、屋外使用、現場での接着に完全な自由を提供します。',
  product_glue_005_feature_2_title: '20Vコードレスバッテリープラットフォーム',
  product_glue_005_feature_2_desc: '20Vバッテリー互換性で他のコードレスツールとパワーを共有し、グルーイングとクラフトのための別の充電器やバッテリー投資が不要です。',
  product_glue_005_feature_3_title: '180〜210°Cコードレス温度',
  product_glue_005_feature_3_desc: 'バッテリーパワーで最適な180〜210°Cの作業温度を維持し、ACモデルとのパフォーマンス妥協なし。',
  product_glue_005_feature_4_title: '8g/分コードレス出力量',
  product_glue_005_feature_4_desc: '8g/分のグルー供給がACモデルと同等で、完全にバッテリーパワーで動作します。',
  product_glue_005_feature_5_title: '電源コードの制限なし',
  product_glue_005_feature_5_desc: 'コードレス設計でどのポジション、どの表面でも、電源コンセントのない場所でも接着を可能にします。',

  product_glue_006_feature_1_title: '100Wスリムプロファイルグルーガン',
  product_glue_006_feature_1_desc: '100Wのスリムバレル設計で標準サイズのガンが届かない狭い隙間や精密塗布位置に入り込めます。',
  product_glue_006_feature_2_title: '190〜220°C制御ホットグルー',
  product_glue_006_feature_2_desc: '190〜220°Cの狭い作業範囲で一定のグルー粘度を生成し、予測可能な塗布ビードコントロールを実現します。',
  product_glue_006_feature_3_title: '6g/分制御フロー',
  product_glue_006_feature_3_desc: '6g/分の制御されたフローで精密作業での過剰塗布を防ぎ、速度よりも品質を優先したディテール接着を実現します。',
  product_glue_006_feature_4_title: '282mmスリムバレル長さ',
  product_glue_006_feature_4_desc: '282mmのスリムボディで狭いキャビネットコーナーや狭い組立隙間への的確な精密グルーイングが可能です。',
  product_glue_006_feature_5_title: '43dBほぼ無音動作',
  product_glue_006_feature_5_desc: '≦43dBはシリーズ最静音で、スタジオや教室環境での事実上無音の動作を実現します。',

  product_glue_007_feature_1_title: '150W工業用スタンドグルーガン',
  product_glue_007_feature_1_desc: '150Wの高パワーガンに水平スタンドを組み合わせ、継続的な大量接着剤塗布が必要な量産環境向けです。',
  product_glue_007_feature_2_title: '200〜240°C工業用温度',
  product_glue_007_feature_2_desc: '200〜240°Cの高温範囲でナイロン、ポリカーボネート、金属などの耐久工業材料の接着が可能です。',
  product_glue_007_feature_3_title: '25g/分最大出力量',
  product_glue_007_feature_3_desc: '25g/分はシリーズ最高の出力量で、高速量産組立の標準レートの3倍です。',
  product_glue_007_feature_4_title: '150W継続量産パワー',
  product_glue_007_feature_4_desc: '150Wの最大パワーで熱回復が継続量産使用中の25g/分出力を維持するのに十分な速さです。',
  product_glue_007_feature_5_title: '内蔵水平レストスタンド',
  product_glue_007_feature_5_desc: '統合スタンドで塗布の間にガンを安全に置き、表面の焼け跡や先端の接触事故を防ぎます。',

  product_glue_008_feature_1_title: '80W低滴りプログルーガン',
  product_glue_008_feature_1_desc: '80Wの防滴ノズル設計で塗布間の余分なグルーの滴りを防ぎ、よりクリーンなワークピースを実現します。',
  product_glue_008_feature_2_title: '170〜210°C防滴温度',
  product_glue_008_feature_2_desc: '最適化された170〜210°Cの範囲でグルーを理想的な粘度に保ち、ノズルでの滴りを最小化します。',
  product_glue_008_feature_3_title: '防滴ノズル設計',
  product_glue_008_feature_3_desc: '精密防滴ノズルバルブでトリガーを放すと即座にグルーの流れが止まり、ワークピースの汚染を防ぎます。',
  product_glue_008_feature_4_title: '8g/分クリーン塗布フロー',
  product_glue_008_feature_4_desc: '8g/分のフロー量と防滴ノズルの組み合わせで最もクリーンで精密なグルー塗布を実現します。',
  product_glue_008_feature_5_title: '0.4kg軽量防滴ツール',
  product_glue_008_feature_5_desc: '0.4kgの軽量本体でこの防滴ガンをクラフトや精密組立アプリケーションで快適に使用できます。',

  product_glue_009_feature_1_title: '100W人体工学的快適グルーガン',
  product_glue_009_feature_1_desc: '100Wのガンに人体工学的なソフトグリップハンドルを組み合わせ、長時間のクラフト、教室、ワークショップでの使用向けに設計されています。',
  product_glue_009_feature_2_title: '185〜225°C拡張温度',
  product_glue_009_feature_2_desc: '185〜225°Cで標準モデルより広い範囲をカバーし、より幅広い種類のグルースティック配合に対応します。',
  product_glue_009_feature_3_title: '人体工学的ソフトグリップハンドル',
  product_glue_009_feature_3_desc: '輪郭のあるソフトグリップハンドルで長いクラフトセッションや授業での手疲労を軽減します。',
  product_glue_009_feature_4_title: '10g/分安定出力',
  product_glue_009_feature_4_desc: '10g/分の出力が速度とコントロールのバランスを取り、量産に十分な速さと細かいクラフト作業に十分な精度を両立します。',
  product_glue_009_feature_5_title: '0.5kg標準快適重量',
  product_glue_009_feature_5_desc: '0.5kgで長時間セッションを不快にせずに安定した塗布のための適切なグリップ重量を提供します。',

  product_glue_010_feature_1_title: '80Wクラシック標準グルーガン',
  product_glue_010_feature_1_desc: '80Wの信頼性の高い標準グルーガンで一般的な接着ニーズ全般のDIY修理、家庭クラフト、軽い組立作業に対応します。',
  product_glue_010_feature_2_title: '180〜210°Cユニバーサル温度',
  product_glue_010_feature_2_desc: '180〜210°Cのユニバーサル範囲で最も広い材料互換性のためにすべての標準11mmグルースティックに対応します。',
  product_glue_010_feature_3_title: '320mm拡張バレル設計',
  product_glue_010_feature_3_desc: '320mmの拡張バレルで棚の奥や深く組み立てられた家具の内部への接着時のリーチを向上します。',
  product_glue_010_feature_4_title: '8g/分信頼性の高い出力',
  product_glue_010_feature_4_desc: '8g/分の信頼性の高い出力で布修理から家の装飾やクラフト製作までの日常的な接着タスクを処理します。',
  product_glue_010_feature_5_title: '0.4kg毎日クラフト重量',
  product_glue_010_feature_5_desc: '0.4kgでこのガンを自発的な家のクラフトプロジェクトや素早い修理タスクに軽快で快適にします。',

  // ===== 木工ツール配件翻訳（ws_acc_*シリーズ）=====

  // ポリッシャー pol-001 配件
  ws_acc_pol001_foam_pads_name: 'フォームパッドセット',
  ws_acc_pol001_foam_pads_desc: '180mm粗/中/細3枚フォームパッドセット、DAデュアルアクションポリッシャー用',
  ws_acc_pol001_compound_name: 'カーコンパウンドセット',
  ws_acc_pol001_compound_desc: '重度/中度/軽度3段階塗装修正コンパウンドセット',
  ws_acc_pol001_backing_plate_name: 'ベルクロバッキングプレート',
  ws_acc_pol001_backing_plate_desc: '180mmバランスベルクロバッキングプレート、パッド素早し交換用',
  ws_acc_pol001_applicators_name: 'フォームワックスアプリケーター',
  ws_acc_pol001_applicators_desc: '丸い柔らかいフォームアプリケーターパッドセット、ワックスとシーラント手塗り用',
  ws_acc_pol001_quick_detailer_name: 'クイックディテーラースプレー',
  ws_acc_pol001_quick_detailer_desc: '500ml塗面クイックディテーラースプレー、光沢維持用',
  ws_acc_pol001_microfiber_name: 'マイクロファイバータオルセット',
  ws_acc_pol001_microfiber_desc: '5枚超柔ら380g/㎡プラッシュマイクロファイバータオル、ワックスと拭き取り用',
  ws_acc_pol001_gloves_name: ' 滑り止め作業グローブ',
  ws_acc_pol001_gloves_desc: 'ゴムパーム滑り止めフィンガーレスグローブ、磨き作業用',
  ws_acc_pol001_bag_name: 'ツールキャリーバッグ',
  ws_acc_pol001_bag_desc: 'EVAハードシェルライニングキャリーバッグ、ポリッシャーと配件整理用',

  // pol-002 配件
  ws_acc_pol002_wool_pad_name: 'ウールカッティングパッド',
  ws_acc_pol002_wool_pad_desc: '150mmウールカッティングパッド、ロータリーポリッシャー重度塗装修正用',
  ws_acc_pol002_compound_name: 'ヘビーカットコンパウンド',
  ws_acc_pol002_compound_desc: '500mlヘビーカッティングコンパウンド、傷と酸化除去用',
  ws_acc_pol002_backing_plate_name: 'バッキングプレート',
  ws_acc_pol002_backing_plate_desc: '150mmネジ式ベルクロバッキングプレート、ロータリーポリッシャー用',
  ws_acc_pol002_compound_remover_name: 'コンパウンドリムーバー',
  ws_acc_pol002_compound_remover_desc: '200mlコンパウンド残留除去スプレー、カーディテーリング必須',
  ws_acc_pol002_wrench_name: 'バッキングプレートレンチ',
  ws_acc_pol002_wrench_desc: 'バッキングプレート安全着脱専用レンチ',
  ws_acc_pol002_microfiber_name: 'プロポリッシュタオル',
  ws_acc_pol002_microfiber_desc: 'プロエッジレス360gマイクロファイバー磨き布',
  ws_acc_pol002_gloves_name: 'メカニカル作業グローブ',
  ws_acc_pol002_gloves_desc: 'ゴムパーム耐磨耗メカニカルグローブ、ロータリーポリッシャー用',
  ws_acc_pol002_bag_name: 'キャンバスツールバッグ',
  ws_acc_pol002_bag_desc: 'ジッパーキャンバスツールバッグ、バッキングプレートとグローブ収納用',

  // pol-003 配件
  ws_acc_pol003_mini_pads_name: 'ミニパッドセット',
  ws_acc_pol003_mini_pads_desc: '125mm5枚多目数フォームパッドセット、ミニポリッシャー用',
  ws_acc_pol003_swirl_remover_name: 'スワールリムーバー',
  ws_acc_pol003_swirl_remover_desc: '250ml細粒仕上げポリッシュスワールリムーバー、鏡面光沢復元',
  ws_acc_pol003_backing_plate_name: 'ミニバッキングプレート',
  ws_acc_pol003_backing_plate_desc: '125mmバランスベルクロミニバッキングプレート、コンパクトポリッシャー用',
  ws_acc_pol003_paint_cleaner_name: 'ペイントクリーナー',
  ws_acc_pol003_paint_cleaner_desc: '200mlプレポリッシュペイントクリーナー、磨き前表面準備用',
  ws_acc_pol003_detail_applicators_name: 'ディテールワックスアプリケーター',
  ws_acc_pol003_detail_applicators_desc: '6枚カーブフォームディテールアプリケーターセット、狭い部分仕上げ用',
  ws_acc_pol003_microfiber_name: 'ファインタオルセット',
  ws_acc_pol003_microfiber_desc: '小サイズ精細ディテーリングマイクロファイバー拭き布セット',
  ws_acc_pol003_finger_guards_name: 'フィンガーガード',
  ws_acc_pol003_finger_guards_desc: 'ゴム指先保護キャップ、精細磨き作業中の擦れ防止用',
  ws_acc_pol003_case_name: 'ミニツールケース',
  ws_acc_pol003_case_desc: '小型ポリッシャーと配件収納用コンパクトハードシェルケース',

  // pol-004 配件
  ws_acc_pol004_large_pads_name: 'ラージパッドセット',
  ws_acc_pol004_large_pads_desc: '200mm8インチ粗/中/細3枚フォームパッドセット、広面積磨き用',
  ws_acc_pol004_compound_name: 'ラージパッドコンパウンド',
  ws_acc_pol004_compound_desc: '500gヘビーカットポリッシュペーストタブ、大型パッドロータリー修正用',
  ws_acc_pol004_backing_plate_name: 'ラージバッキングプレート',
  ws_acc_pol004_backing_plate_desc: '200mm8インチベルクロラージバッキングプレート、広面積磨き用',
  ws_acc_pol004_wax_applicators_name: 'ワックスアプリケーターパッド',
  ws_acc_pol004_wax_applicators_desc: '広面積ワックスフォームアプリケーターパッドセット、広面積ワックスとコーティング用',
  ws_acc_pol004_paint_gauge_name: 'ペイント厚さゲージ',
  ws_acc_pol004_paint_gauge_desc: 'デジタル自動車塗装コーティング厚さ測定ゲージ',
  ws_acc_pol004_cleaning_cloths_name: 'ラージクリーニングクロス',
  ws_acc_pol004_cleaning_cloths_desc: '60×40cmラージクリーニングクロス、大型パッド磨き後のコンパウンド拭き取り用',
  ws_acc_pol004_gloves_name: 'ニトリルコーティンググローブ',
  ws_acc_pol004_gloves_desc: 'ニトリルパームコーティング安全グローブ、大面積ヘビーデューティー磨き用',
  ws_acc_pol004_toolbox_name: 'プロツールボックス',
  ws_acc_pol004_toolbox_desc: '大容量プロツールボックス、8インチパッドと磨き配件収納用',

  // pol-005 配件
  ws_acc_pol005_speed_pads_name: '可変速パッド',
  ws_acc_pol005_speed_pads_desc: '180mm可変速対応フォームパッドセット、多段速ポリッシャー用',
  ws_acc_pol005_compound_set_name: '3段階コンパウンドセット',
  ws_acc_pol005_compound_set_desc: '第1・第2・第3段階完全塗装修正コンパウンドシステム',
  ws_acc_pol005_backing_plate_name: '可変速バッキングプレート',
  ws_acc_pol005_backing_plate_desc: '180mmバランスベルクロ可変速対応バッキングプレート',
  ws_acc_pol005_correction_disc_name: 'ペイント修正ディスク',
  ws_acc_pol005_correction_disc_desc: '180mmヘビーカット修正フォームディスク、スワールと傷修正用',
  ws_acc_pol005_lubricant_name: 'マシン潤滑剤',
  ws_acc_pol005_lubricant_desc: 'ポリッシャーギアグリース小チューブ、定期メンテナンス用',
  ws_acc_pol005_microfiber_name: 'マイクロファイバータオル',
  ws_acc_pol005_microfiber_desc: '6枚デュアルパイルループマイクロファイバーカーディテーリングタオルセット',
  ws_acc_pol005_gloves_name: '防振グローブ',
  ws_acc_pol005_gloves_desc: 'シリコン防振パーム作業グローブ、可変速ポリッシャー用',
  ws_acc_pol005_manual_name: 'スピードチャートガイド',
  ws_acc_pol005_manual_desc: '可変速ポリッシャー速度設定と材料対応参照チャートマニュアル',

  // pol-006 配件
  ws_acc_pol006_combo_pads_name: 'コンボパッドセット',
  ws_acc_pol006_combo_pads_desc: '150mmデュアルモードロータリー軌道コンボフォームウール混合パッドセット',
  ws_acc_pol006_dual_compound_name: 'デュアルモードコンパウンドセット',
  ws_acc_pol006_dual_compound_desc: 'ロータリーとDAの両モード専用コンパウンドセット',
  ws_acc_pol006_backing_plate_name: 'デュアルモードバッキングプレート',
  ws_acc_pol006_backing_plate_desc: '150mmデュアルモードロータリー軌道切替対応バッキングプレート',
  ws_acc_pol006_pad_primer_name: 'パッドプライマースプレー',
  ws_acc_pol006_pad_primer_desc: 'フォームパッド調整スプレー、使用前パッド準備用',
  ws_acc_pol006_cleaning_brushes_name: 'パッドクリーニングブラシセット',
  ws_acc_pol006_cleaning_brushes_desc: '硬軟ブリッスルフォームパッドクリーニングブラシセット、パッドメンテ用',
  ws_acc_pol006_microfiber_name: 'マイクロファイバータオル',
  ws_acc_pol006_microfiber_desc: 'プロワッフル織りマイクロファイバー拭き布セット、デュアルモード磨き用',
  ws_acc_pol006_gloves_name: '防振グローブ',
  ws_acc_pol006_gloves_desc: 'シリコンパーム防振メカニカルグローブ、デュアルモードポリッシャー用',
  ws_acc_pol006_bag_name: 'パッド入りキャリーバッグ',
  ws_acc_pol006_bag_desc: '外部ポケット付きパッドナイロンキャリーバッグ、デュアルモードポリッシャー収納用',

  // pol-007 配件（コードレス）
  ws_acc_pol007_battery_name: 'リチウムバッテリー',
  ws_acc_pol007_battery_desc: '20V 4Ahコードレスポリッシャー用リチウムバッテリー、十分な稼働時間',
  ws_acc_pol007_charger_name: '急速充電器',
  ws_acc_pol007_charger_desc: '20Vリチウムバッテリー1時間急速充電器',
  ws_acc_pol007_foam_pads_name: 'フォームパッドセット',
  ws_acc_pol007_foam_pads_desc: '125mm3枚コードレスポリッシャー用フォームパッドセット',
  ws_acc_pol007_compound_name: 'コードレス用コンパウンド',
  ws_acc_pol007_compound_desc: '250ml軽/中度カットコンパウンド、コードレスモバイル磨き用',
  ws_acc_pol007_backing_plate_name: 'バッキングプレート',
  ws_acc_pol007_backing_plate_desc: '125mmベルクロバッキングプレート、コードレスポリッシャー用',
  ws_acc_pol007_microfiber_name: 'モバイル作業タオルセット',
  ws_acc_pol007_microfiber_desc: 'コードレスモバイルディテーリング用コンパクトマイクロファイバータオルセット',
  ws_acc_pol007_holster_name: 'ベルトホルスター',
  ws_acc_pol007_holster_desc: 'コードレスポリッシャーモバイル作業時ベルト携帯用ホルスター',
  ws_acc_pol007_bag_name: 'キャリーバッグ',
  ws_acc_pol007_bag_desc: 'バッテリー・充電器・パッドコンパートメント付きコードレスポリッシャーキャリーバッグ',

  // pol-008 配件（空気圧）
  ws_acc_pol008_air_connector_name: 'エアクイックカプラー',
  ws_acc_pol008_air_connector_desc: '3/8インチエアホースクイックカプラー、空気圧ポリッシャー用',
  ws_acc_pol008_air_filter_name: 'エアフィルターレギュレーター',
  ws_acc_pol008_air_filter_desc: '空気圧ツール用インラインフィルターレギュレーター水トラップ',
  ws_acc_pol008_foam_pads_name: '空気圧用パッドセット',
  ws_acc_pol008_foam_pads_desc: '180mm空気圧ポリッシャー粗/中/細フォームパッドセット',
  ws_acc_pol008_compound_name: '空気圧用コンパウンド',
  ws_acc_pol008_compound_desc: '250ml中度カットコンパウンド、空気圧ポリッシャー用',
  ws_acc_pol008_backing_plate_name: '空気圧バッキングプレート',
  ws_acc_pol008_backing_plate_desc: '180mmネジ取り付けベルクロバッキングプレート、空気圧ポリッシャー用',
  ws_acc_pol008_microfiber_name: 'インダストリアルマイクロファイバー',
  ws_acc_pol008_microfiber_desc: 'インダストリアルマイクロファイバーディテーリングワイプ大容量パック',
  ws_acc_pol008_ear_protection_name: 'イヤーマフ',
  ws_acc_pol008_ear_protection_desc: '空気圧ツール使用時安全聴覚保護イヤーマフ',
  ws_acc_pol008_manual_name: '気圧マニュアル',
  ws_acc_pol008_manual_desc: '空気圧ポリッシャー気圧チャートと設置操作ガイド',

  // pol-009 配件（湿式）
  ws_acc_pol009_diamond_pads_name: 'ダイヤモンドパッドセット',
  ws_acc_pol009_diamond_pads_desc: '50〜3000番石材大理石湿式ダイヤモンド磨きパッドセット',
  ws_acc_pol009_stone_polish_name: 'ストーンポリッシュクリーム',
  ws_acc_pol009_stone_polish_desc: '500ml大理石花崗岩カウンタートップ復元鏡面光沢ストーンポリッシュ',
  ws_acc_pol009_water_nozzle_name: '水冷ノズル',
  ws_acc_pol009_water_nozzle_desc: '湿式石材磨き用継続的な水流冷却供給ノズル',
  ws_acc_pol009_backing_plate_name: '防水バッキングプレート',
  ws_acc_pol009_backing_plate_desc: '150mm防水シールドベルクロバッキングプレート、湿式石材ポリッシャー用',
  ws_acc_pol009_shroud_name: '水偏向シュラウド',
  ws_acc_pol009_shroud_desc: '湿式ポリッシャータイル作業用ゴム水偏向シュラウド',
  ws_acc_pol009_gloves_name: '防水グローブ',
  ws_acc_pol009_gloves_desc: '湿式石材磨き作業用厚手ゴム防水グローブ',
  ws_acc_pol009_apron_name: '防水ワークエプロン',
  ws_acc_pol009_apron_desc: '湿式石材磨き防水防飛散ゴムエプロン',
  ws_acc_pol009_manual_name: '操作マニュアル',
  ws_acc_pol009_manual_desc: '湿式石材ポリッシャー水圧設定と操作ガイド',

  // pol-010 配件（スマートLCD）
  ws_acc_pol010_pad_set_name: 'スマートパッドセット',
  ws_acc_pol010_pad_set_desc: '180mm番手ラベル付きスマートLCDポリッシャー用フォームパッドセット',
  ws_acc_pol010_compound_set_name: 'スマートコンパウンドセット',
  ws_acc_pol010_compound_set_desc: '3段階ラベル分類スマートディスプレイポリッシャー用コンパウンドセット',
  ws_acc_pol010_backing_plate_name: '精密バランスプレート',
  ws_acc_pol010_backing_plate_desc: '180mm精密バランスバッキングプレート、スマートLCDポリッシャー用',
  ws_acc_pol010_microfiber_name: 'マイクロファイバータオル',
  ws_acc_pol010_microfiber_desc: 'スマートポリッシャーカーディテーリング用プレミアムマイクロファイバータオルセット',
  ws_acc_pol010_data_cable_name: 'USBデータケーブル',
  ws_acc_pol010_data_cable_desc: 'スマートポリッシャーLCDファームウェアアップグレードとデータ転送用USBケーブル',
  ws_acc_pol010_lcd_shield_name: 'LCD画面保護フィルム',
  ws_acc_pol010_lcd_shield_desc: 'スマートディスプレイポリッシャー用傷防止LCD画面保護フィルム',
  ws_acc_pol010_gloves_name: 'タッチスクリーン対応グローブ',
  ws_acc_pol010_gloves_desc: 'スマートLCDポリッシャー操作対応タッチスクリーン互換作業グローブ',
  ws_acc_pol010_case_name: 'プレミアムハードケース',
  ws_acc_pol010_case_desc: 'スマートLCDポリッシャー収納用フォームライニングプレミアムハードケース',

  // サンダー san-001 配件
  ws_acc_san001_discs_name: 'サンディングディスクセット',
  ws_acc_san001_discs_desc: '125mm多目数80/120/180/240フックアンドループ軌道サンダー用ディスクセット',
  ws_acc_san001_dust_bag_name: '集塵袋',
  ws_acc_san001_dust_bag_desc: '125mm軌道サンダー用再使用可能フィルター集塵袋',
  ws_acc_san001_backing_plate_name: 'サンディングパッド',
  ws_acc_san001_backing_plate_desc: '125mmソフトインターフェースベルクロサンディングパッド',
  ws_acc_san001_sanding_sponge_name: 'サンディングスポンジブロック',
  ws_acc_san001_sanding_sponge_desc: '柔軟多目数輪郭サンディングスポンジ、曲面木材用',
  ws_acc_san001_cleaning_brush_name: 'ディスククリーニングブラシ',
  ws_acc_san001_cleaning_brush_desc: 'ベルクロサンディングディスクから鋸屑除去用硬毛ブラシ',
  ws_acc_san001_dust_mask_name: '防塵マスク',
  ws_acc_san001_dust_mask_desc: 'N95 FFP2防塵マスク、木工サンディング粉塵防護用',
  ws_acc_san001_goggles_name: '安全ゴーグル',
  ws_acc_san001_goggles_desc: '透明防曇レンズ安全ゴーグル、サンディング粉塵目保護用',
  ws_acc_san001_case_name: 'サンダー収納ケース',
  ws_acc_san001_case_desc: 'サンディングディスクコンパートメント付きサンダーツール収納ケース',

  // san-002 配件
  ws_acc_san002_discs_name: '150mmディスクセット',
  ws_acc_san002_discs_desc: '150mm6穴フックアンドループディスクセット、60/80/120/180/240番',
  ws_acc_san002_dust_bag_name: '大容量集塵袋',
  ws_acc_san002_dust_bag_desc: '150mm軌道サンダー用大容量フィルターキャンバス集塵袋',
  ws_acc_san002_backing_plate_name: '150mmサンディングパッド',
  ws_acc_san002_backing_plate_desc: '150mm6インチ軌道サンダー用ベルクロバッキングパッド',
  ws_acc_san002_contour_block_name: '輪郭サンディングブロック',
  ws_acc_san002_contour_block_desc: '曲面木工サンディング用人体工学フォーム輪郭ブロック',
  ws_acc_san002_cleaning_brush_name: 'ディスククリーニングブラシ',
  ws_acc_san002_cleaning_brush_desc: '6インチサンディングディスクベルクロから鋸屑除去ナイロンブラシ',
  ws_acc_san002_goggles_name: 'ラップアラウンドゴーグル',
  ws_acc_san002_goggles_desc: 'ラップアラウンド透明レンズ安全ゴーグル、木工サンディング粉塵保護用',
  ws_acc_san002_mask_name: 'ハーフフェイスレスピレーター',
  ws_acc_san002_mask_desc: '木工サンディング細粒子フィルタリング用ハーフフェイス防塵レスピレーター',
  ws_acc_san002_bag_name: 'サンダーツールバッグ',
  ws_acc_san002_bag_desc: 'ベルクロディスクポケット付き軌道サンダーナイロンキャリーバッグ',

  // san-003 配件
  ws_acc_san003_triangle_sheets_name: '三角形シートセット',
  ws_acc_san003_triangle_sheets_desc: 'フックアンドループ三角形ディテールサンダーシートセット、60/120/240番',
  ws_acc_san003_corner_pads_name: 'コーナーサンディングパッド',
  ws_acc_san003_corner_pads_desc: '先端フォームバッキング三角形コーナーパッド、狭い角度サンディング用',
  ws_acc_san003_backing_plate_name: '三角形バッキングプレート',
  ws_acc_san003_backing_plate_desc: '柔軟ベルクロ三角形バッキングプレート、コーナーディテールサンダー用',
  ws_acc_san003_finger_cap_name: 'フィンガーサンディングキャップ',
  ws_acc_san003_finger_cap_desc: 'ゴム先端指サンディングキャップ、狭い隙間手サンディング用',
  ws_acc_san003_dust_bag_name: 'ミニ集塵袋',
  ws_acc_san003_dust_bag_desc: 'コンパクト再使用可能フィルター集塵袋、三角形ディテールサンダー用',
  ws_acc_san003_tweezers_name: '精密ピンセットセット',
  ws_acc_san003_tweezers_desc: 'コーナーサンディング残留物除去用精密ピンセットツールセット',
  ws_acc_san003_mask_name: 'FFP2防塵マスク',
  ws_acc_san003_mask_desc: 'ディテールサンディング細粒子防護用FFP2 N95防塵マスク',
  ws_acc_san003_manual_name: 'ユーザーガイド',
  ws_acc_san003_manual_desc: 'ディテールサンダー操作ガイドとコーナーサンディングテクニック',

  // san-004 配件
  ws_acc_san004_belts_name: 'サンディングベルトセット',
  ws_acc_san004_belts_desc: '200mm幅ベルトセット、40/60/80/120番ベルトサンダー用',
  ws_acc_san004_tracking_tool_name: 'ベルトトラッキングツール',
  ws_acc_san004_tracking_tool_desc: '幅広ベルトサンダー用ベルトアライメント調整レンチ',
  ws_acc_san004_belt_clips_name: 'ベルトクリップ',
  ws_acc_san004_belt_clips_desc: '幅広ベルトサンダー用スペアベルト固定クリップセット',
  ws_acc_san004_guide_frame_name: 'ガイドフェンス',
  ws_acc_san004_guide_frame_desc: '幅広ベルトサンダー直線カット制御ガイドフェンスフレーム',
  ws_acc_san004_cleaning_stick_name: 'ベルトクリーニング消しゴム',
  ws_acc_san004_cleaning_stick_desc: '目詰まり鋸屑除去用研磨ベルトクリーニング消しゴム',
  ws_acc_san004_dust_bag_name: '大容量集塵袋',
  ws_acc_san004_dust_bag_desc: 'ベルトサンダー用大容量高効率フィルター集塵袋',
  ws_acc_san004_gloves_name: '耐切断グローブ',
  ws_acc_san004_gloves_desc: 'ベルトサンダー操作用耐切断耐摩耗作業グローブ',
  ws_acc_san004_manual_name: 'ベルト交換ガイド',
  ws_acc_san004_manual_desc: 'ベルトサンダーユーザーマニュアル、ベルト交換と安全操作説明',

  // san-005 配件
  ws_acc_san005_grit_discs_name: '多目数ディスクセット',
  ws_acc_san005_grit_discs_desc: '125mm 60〜600番全レンジディスクセット、可変速サンダー用',
  ws_acc_san005_speed_pads_name: '速度フォームパッド',
  ws_acc_san005_speed_pads_desc: '125mm可変速サンダー対応異密度フォームパッド',
  ws_acc_san005_backing_plate_name: 'ソフトインターフェースパッド',
  ws_acc_san005_backing_plate_desc: '125mm交換可能ソフトインターフェースベルクロバッキングパッド',
  ws_acc_san005_contour_kit_name: '輪郭サンディングキット',
  ws_acc_san005_contour_kit_desc: '多形状フォーム輪郭サンディングキット、曲面用',
  ws_acc_san005_cleaning_brush_name: 'ディスククリーニングブラシ',
  ws_acc_san005_cleaning_brush_desc: '可変速サンダー用ベルクロパッドメンテナンスクリーニングブラシ',
  ws_acc_san005_mask_name: '防塵レスピレーター',
  ws_acc_san005_mask_desc: '可変速木工サンディング用フィルター防塵レスピレーター',
  ws_acc_san005_pouch_name: 'ディスク収納ポーチ',
  ws_acc_san005_pouch_desc: 'サンディングディスク配件整理用ロールアップ収納ポーチ',
  ws_acc_san005_manual_name: '速度材料チャート',
  ws_acc_san005_manual_desc: '可変速サンダー速度設定と材料対応参照カード',

  // san-006 配件（ウェット/ドライ）
  ws_acc_san006_wet_discs_name: 'ウェット/ドライサンディングディスク',
  ws_acc_san006_wet_discs_desc: '150mm炭化ケイ素ウェット/ドライサンディングディスクセット',
  ws_acc_san006_drain_tube_name: 'ドレインホース',
  ws_acc_san006_drain_tube_desc: 'ウェット/ドライサンダー用排水ドレインホース',
  ws_acc_san006_sealing_ring_name: 'シールリングセット',
  ws_acc_san006_sealing_ring_desc: 'ウェット/ドライサンダー用防水シールリングガスケットセット',
  ws_acc_san006_backing_plate_name: '防水バッキングプレート',
  ws_acc_san006_backing_plate_desc: '150mm防錆防水バッキングプレート、ウェット/ドライサンダー用',
  ws_acc_san006_squeegee_name: 'ゴムスクレーパー',
  ws_acc_san006_squeegee_desc: '湿式サンディング残留物除去用ゴムスクレーパー',
  ws_acc_san006_gloves_name: '防水グローブ',
  ws_acc_san006_gloves_desc: 'マリン湿式サンディング用ニトリル防水グローブ',
  ws_acc_san006_apron_name: '防水エプロン',
  ws_acc_san006_apron_desc: 'マリン湿式サンディング用防水防飛散作業エプロン',
  ws_acc_san006_manual_name: 'ウェット/ドライ使用ガイド',
  ws_acc_san006_manual_desc: 'ウェット/ドライサンダー防水操作ガイドと安全注意事項',

  // san-007 配件（コードレス）
  ws_acc_san007_battery_name: 'リチウムバッテリー',
  ws_acc_san007_battery_desc: '20V 3Ahコードレスサンダー用リチウムバッテリー、安定供電',
  ws_acc_san007_charger_name: '急速充電器',
  ws_acc_san007_charger_desc: '20Vリチウムバッテリー1時間急速充電器',
  ws_acc_san007_discs_name: 'コードレスディスクパック',
  ws_acc_san007_discs_desc: '125mm40枚多目数フックアンドループディスクパック、コードレスサンダー用',
  ws_acc_san007_dust_bag_name: '集塵袋',
  ws_acc_san007_dust_bag_desc: 'コードレスサンダー用コンパクトフィルター集塵袋替え',
  ws_acc_san007_backing_plate_name: 'サンディングパッド',
  ws_acc_san007_backing_plate_desc: '125mmベルクロバッキングパッド替え、コードレスサンダー用',
  ws_acc_san007_cleaning_brush_name: 'ディスククリーニングブラシ',
  ws_acc_san007_cleaning_brush_desc: 'ベルクロパッドメンテナンスクリーニングブラシ、コードレスサンダー用',
  ws_acc_san007_bag_name: 'コードレスキャリーバッグ',
  ws_acc_san007_bag_desc: 'バッテリー・充電器・ディスクポケット付きコードレスサンダーキャリーバッグ',
  ws_acc_san007_manual_name: 'バッテリーケアマニュアル',
  ws_acc_san007_manual_desc: 'コードレスサンダーバッテリーメンテナンスと操作説明書',

  // san-008 配件（空気圧）
  ws_acc_san008_air_fitting_name: 'エアクイックカプラー',
  ws_acc_san008_air_fitting_desc: '1/4インチNPTエアホースクイックカプラー、空気圧パームサンダー用',
  ws_acc_san008_inline_oiler_name: 'インラインオイラー',
  ws_acc_san008_inline_oiler_desc: '空気圧サンダーメンテナンス用インラインエアオイラー潤滑器',
  ws_acc_san008_sheets_name: 'パームシートセット',
  ws_acc_san008_sheets_desc: '100mm空気圧パームサンダー用80/120/180/240シートセット',
  ws_acc_san008_dust_bag_name: '集塵袋',
  ws_acc_san008_dust_bag_desc: '空気圧パームサンダー用コンパクト再使用可能フィルター集塵袋',
  ws_acc_san008_rubber_pad_name: 'ゴムサンディングパッド',
  ws_acc_san008_rubber_pad_desc: '100mmベルクロゴムサンディングパッド、空気圧パームサンダー用',
  ws_acc_san008_ear_plugs_name: '耳栓',
  ws_acc_san008_ear_plugs_desc: '空気圧ツールノイズ聴覚保護用フォーム耳栓',
  ws_acc_san008_gloves_name: '防振グローブ',
  ws_acc_san008_gloves_desc: 'シリコンパーム防振グローブ、空気圧パームサンダー用',
  ws_acc_san008_manual_name: '気圧チャートマニュアル',
  ws_acc_san008_manual_desc: '空気圧パームサンダー気圧設定チャートと操作ガイド',

  // san-009 配件（壁・天井）
  ws_acc_san009_extension_pole_name: '伸縮延長ポール',
  ws_acc_san009_extension_pole_desc: '1.5〜3m伸縮延長ポールコネクター、天井壁サンダー用',
  ws_acc_san009_ceiling_discs_name: '天井用ディスク',
  ws_acc_san009_ceiling_discs_desc: '150mm天井壁サンダー用60/80/120/180番ディスクセット',
  ws_acc_san009_flex_head_name: 'フレックスアーティキュレーティングヘッド',
  ws_acc_san009_flex_head_desc: '長ポール天井角度調整用フレキシブルアーティキュレーティングヘッド',
  ws_acc_san009_dust_hose_name: '集塵ホース延長',
  ws_acc_san009_dust_hose_desc: '長ポール天井サンダー用掃除機接続延長ホース',
  ws_acc_san009_goggles_name: '頭上作業ゴーグル',
  ws_acc_san009_goggles_desc: '落下する頭上サンディング粉塵から目を保護するシール型安全ゴーグル',
  ws_acc_san009_neck_strap_name: 'ネックサポートストラップ',
  ws_acc_san009_neck_strap_desc: '長ポールサンダー重量支持用調節可能ネック・ショルダーストラップ',
  ws_acc_san009_gloves_name: '頭上作業グローブ',
  ws_acc_san009_gloves_desc: '長カフ手首保護グローブ、頭上天井サンディング用',
  ws_acc_san009_manual_name: '延長ポールマニュアル',
  ws_acc_san009_manual_desc: '長ポール天井サンダー設置と頭上作業安全操作ガイド',

  // san-010 配件（静音）
  ws_acc_san010_low_vib_discs_name: '低振動ディスクセット',
  ws_acc_san010_low_vib_discs_desc: '125mmバランス低振動サンディングディスク、静音サンダー用',
  ws_acc_san010_acoustic_pad_name: '吸音インターフェースパッド',
  ws_acc_san010_acoustic_pad_desc: '振動減衰吸音フォームインターフェースパッド、静音サンダー用',
  ws_acc_san010_quiet_bag_name: '静音集塵袋',
  ws_acc_san010_quiet_bag_desc: 'シール低気流ノイズフィルター集塵袋、静音サンダー用',
  ws_acc_san010_vib_gloves_name: '防振ゲルグローブ',
  ws_acc_san010_vib_gloves_desc: 'シリコン防振強化快適グローブ、静音サンダー用',
  ws_acc_san010_backing_plate_name: 'ソフトインターフェースパッド',
  ws_acc_san010_backing_plate_desc: '125mm追加減衰ソフトインターフェースバッキングパッド、静音サンダー用',
  ws_acc_san010_cleaning_brush_name: 'ディスククリーニングブラシ',
  ws_acc_san010_cleaning_brush_desc: 'ベルクロディスクメンテナンスクリーニングブラシ、静音サンダー用',
  ws_acc_san010_case_name: '衝撃吸収ケース',
  ws_acc_san010_case_desc: 'フォーム充填衝撃吸収保護ケース、静音低ノイズサンダー用',
  ws_acc_san010_manual_name: 'ノイズスペックマニュアル',
  ws_acc_san010_manual_desc: '静音サンダーノイズ仕様ガイドとサイレント操作説明書',

  // ホットグルーガン glue-001 配件
  ws_acc_glue001_sticks_name: 'グルースティックセット',
  ws_acc_glue001_sticks_desc: '11mm標準ホットグルースティック50本入り、透明汎用強力接着',
  ws_acc_glue001_nozzle_name: '交換用ノズル',
  ws_acc_glue001_nozzle_desc: '標準11mmネジ式交換ノズル、ホットグルーガン用',
  ws_acc_glue001_cleaner_name: 'ノズルクリーニングツール',
  ws_acc_glue001_cleaner_desc: 'グルー詰まり除去用ホットグルーガンノズル通し針セット',
  ws_acc_glue001_mat_name: 'シリコン耐熱マット',
  ws_acc_glue001_mat_desc: 'グルーイング作業中表面保護用耐熱シリコンワークマット',
  ws_acc_glue001_stand_name: 'グルーガン休止スタンド',
  ws_acc_glue001_stand_desc: '塗布間の安全な直立休止用金属グルーガンスタンド',
  ws_acc_glue001_finger_protectors_name: 'シリコン指キャップ',
  ws_acc_glue001_finger_protectors_desc: 'ホットグルーガン作業用防烫シリコン指先保護キャップセット',
  ws_acc_glue001_gloves_name: '耐熱グローブ',
  ws_acc_glue001_gloves_desc: 'ホットグルーガンクラフト作業用耐熱保護グローブ',
  ws_acc_glue001_bag_name: 'キャリーバッグ',
  ws_acc_glue001_bag_desc: 'グルースティックポケット付きホットグルーガン収納ナイロンキャリーバッグ',

  // glue-002 配件（工業用高温）
  ws_acc_glue002_industrial_sticks_name: '工業用グルースティック',
  ws_acc_glue002_industrial_sticks_desc: '11mm工業強力ホットグルースティック30本入り、ヘビーデューティー用',
  ws_acc_glue002_wide_nozzle_name: 'ワイドフラットノズル',
  ws_acc_glue002_wide_nozzle_desc: '11mm工業用高温グルーガン用広幅フラットカバレッジノズル',
  ws_acc_glue002_funnel_nozzle_name: 'ファンネルノズル',
  ws_acc_glue002_funnel_nozzle_desc: '工業用高温ガン用広幅ギャップ充填ファンネル形ノズル',
  ws_acc_glue002_cleaning_kit_name: 'クリーニングキット',
  ws_acc_glue002_cleaning_kit_desc: '工業用高温グルーガン用ブラシ・針・溶剤クリーニングキット',
  ws_acc_glue002_mat_name: 'ラージシリコンマット',
  ws_acc_glue002_mat_desc: '工業用高温グルーガン作業用大型ノンスティック耐熱シリコンマット',
  ws_acc_glue002_heat_gloves_name: '200°C耐熱グローブ',
  ws_acc_glue002_heat_gloves_desc: '200°C定格耐熱作業グローブ、工業用高温グルーガン用',
  ws_acc_glue002_stand_name: 'ヘビーデューティースタンド',
  ws_acc_glue002_stand_desc: '工業用高温グルーガン安定休止用ヘビーデューティー金属スタンド',
  ws_acc_glue002_case_name: 'ツールボックス',
  ws_acc_glue002_case_desc: '工業用高温グルーガンノズルと配件用ハードシェルツールボックス',

  // glue-003 配件（ミニ）
  ws_acc_glue003_mini_sticks_name: '7mmミニグルースティック',
  ws_acc_glue003_mini_sticks_desc: '7mmミニホットグルースティック100本入り、透明細型クラフト用',
  ws_acc_glue003_fine_nozzle_name: '細先精密ノズル',
  ws_acc_glue003_fine_nozzle_desc: '7mmミニガン少量塗布用細先精密ノズル',
  ws_acc_glue003_wiper_name: 'ノズルワイパーパッド',
  ws_acc_glue003_wiper_desc: 'ミニホットグルーガン用防滴シリコンノズルワイプパッド',
  ws_acc_glue003_stand_name: 'ミニ休止スタンド',
  ws_acc_glue003_stand_desc: 'ミニホットグルーガン用小型サポート休止スタンド',
  ws_acc_glue003_tweezers_name: 'クラフトピンセット',
  ws_acc_glue003_tweezers_desc: 'ミニグルーガンクラフト作業の小さな部品位置決め用ピンセット',
  ws_acc_glue003_craft_mat_name: 'クラフトワークマット',
  ws_acc_glue003_craft_mat_desc: 'ミニグルーガンクラフトプロジェクト用小型シリコンワークマット',
  ws_acc_glue003_finger_guard_name: 'フィンガーガード',
  ws_acc_glue003_finger_guard_desc: 'ミニグルーガンを使ったクラフト詳細作業用防烫フィンガーガード',
  ws_acc_glue003_manual_name: 'ユーザーマニュアル',
  ws_acc_glue003_manual_desc: 'ミニホットグルーガン操作ガイドとクラフト作りインスピレーション',

  // glue-004 配件（デュアル温度）
  ws_acc_glue004_color_sticks_name: 'カラーコードスティックセット',
  ws_acc_glue004_color_sticks_desc: 'デュアル温度グルーガン高/低温色分け11mmホットグルースティックセット',
  ws_acc_glue004_dual_nozzle_name: 'デュアル温度ノズル',
  ws_acc_glue004_dual_nozzle_desc: 'デュアルモードグルーガン用高低温対応ノズル',
  ws_acc_glue004_adapter_name: 'ノズルアダプターセット',
  ws_acc_glue004_adapter_desc: 'デュアル温度グルーガン多チップノズル設定用アダプターセット',
  ws_acc_glue004_temp_chart_name: '温度チャート',
  ws_acc_glue004_temp_chart_desc: 'デュアル温度グルーガン温度と材料互換性参照カード',
  ws_acc_glue004_mat_name: 'デュアルゾーンマット',
  ws_acc_glue004_mat_desc: 'デュアル温度グルーガンプロジェクト用デュアルゾーン耐熱シリコンワークマット',
  ws_acc_glue004_gloves_name: 'シリコン作業グローブ',
  ws_acc_glue004_gloves_desc: 'デュアル温度グルーガン使用用防烫シリコン作業グローブ',
  ws_acc_glue004_stand_name: '休止スタンド',
  ws_acc_glue004_stand_desc: 'デュアル温度ホットグルーガン用金属サポートスタンド',
  ws_acc_glue004_pouch_name: '配件収納ポーチ',
  ws_acc_glue004_pouch_desc: 'デュアル温度グルーガンノズルとスティック配件用収納ポーチ',

  // glue-005 配件（コードレス）
  ws_acc_glue005_battery_name: 'リチウムバッテリー',
  ws_acc_glue005_battery_desc: '20V 2Ahコードレスホットグルーガン用充電式リチウムバッテリー',
  ws_acc_glue005_charger_name: '充電器',
  ws_acc_glue005_charger_desc: '20Vリチウムバッテリーコードレスグルーガン用急速充電ドック',
  ws_acc_glue005_sticks_name: 'グルースティック',
  ws_acc_glue005_sticks_desc: '11mmグルースティック30本入り、コードレス20Vグルーガンモバイル用',
  ws_acc_glue005_nozzle_name: '交換用ノズル',
  ws_acc_glue005_nozzle_desc: '11mmネジ式交換ノズルスペア、コードレスグルーガン用',
  ws_acc_glue005_mat_name: 'ポータブルシリコンマット',
  ws_acc_glue005_mat_desc: 'コードレスグルーガンフィールド作業用ポータブル耐熱シリコンマット',
  ws_acc_glue005_holster_name: 'ベルトホルスター',
  ws_acc_glue005_holster_desc: 'コードレスホットグルーガンモバイル作業時ベルト携帯ホルスター',
  ws_acc_glue005_finger_guard_name: 'フィンガーガード',
  ws_acc_glue005_finger_guard_desc: 'コードレスグルーガンモバイル作業用防烫シリコンフィンガーガード',
  ws_acc_glue005_bag_name: 'キャリーバッグ',
  ws_acc_glue005_bag_desc: 'バッテリー・充電器・スティックコンパートメント付きコードレスグルーガンキャリーバッグ',

  // glue-006 配件（精密）
  ws_acc_glue006_precision_sticks_name: '精密グルースティック',
  ws_acc_glue006_precision_sticks_desc: '11mm精密細型グルースティック40本入り、ディテールクラフト用',
  ws_acc_glue006_nozzle_set_name: '精密ノズルセット',
  ws_acc_glue006_nozzle_set_desc: '精密グルーガン用異径5種精密ノズルセット',
  ws_acc_glue006_cleaner_pin_name: 'ノズルクリーニングピン',
  ws_acc_glue006_cleaner_pin_desc: '細先グルーガン精密通し専用ノズルクリーニングピンツール',
  ws_acc_glue006_work_mat_name: 'グリッドワークマット',
  ws_acc_glue006_work_mat_desc: '目盛りグリッド測定付き精密グルーガンクラフト用ワークマット',
  ws_acc_glue006_stand_name: '精密ガンスタンド',
  ws_acc_glue006_stand_desc: '細先ノズル作業用傾斜休止スタンド、精密ホットグルーガン用',
  ws_acc_glue006_magnifier_name: '拡大鏡スタンド',
  ws_acc_glue006_magnifier_desc: '精密クラフトディテールグルーガン作業用ハンズフリー拡大鏡スタンド',
  ws_acc_glue006_finger_guard_name: 'フィンガーガード',
  ws_acc_glue006_finger_guard_desc: '精密グルーガンを使ったクラフト詳細作業用防烫フィンガーガード',
  ws_acc_glue006_case_name: '精密収納ケース',
  ws_acc_glue006_case_desc: '精密グルーガン細先ノズル配件収納用フォームライニングケース',

  // glue-007 配件（工業用大型）
  ws_acc_glue007_cartridges_name: '43mmグルーカートリッジ',
  ws_acc_glue007_cartridges_desc: '43mm工業用ホットメルトグルーカートリッジ10本入り、高粘度ヘビーデューティー',
  ws_acc_glue007_wide_nozzle_name: 'ワイドエッジノズル',
  ws_acc_glue007_wide_nozzle_desc: '43mm工業用グルーガン用フラット広幅カバレッジノズル',
  ws_acc_glue007_ext_nozzle_name: '延長ノズル',
  ws_acc_glue007_ext_nozzle_desc: '43mm工業用グルーガン深部窪み作業用延長ノズル',
  ws_acc_glue007_cleaning_rod_name: 'バレルクリーニングロッド',
  ws_acc_glue007_cleaning_rod_desc: '43mmガンバレルからグルー残留除去用金属クリーニングロッド',
  ws_acc_glue007_mat_name: 'ヘビーデューティーシリコンマット',
  ws_acc_glue007_mat_desc: '工業用高温ガン用ヘビーデューティー耐熱シリコンワークマット',
  ws_acc_glue007_heat_gloves_name: '300°C工業用グローブ',
  ws_acc_glue007_heat_gloves_desc: '大型ホットグルーガン操作用300°C定格工業耐熱グローブ',
  ws_acc_glue007_stand_name: 'ヘビーデューティースタンド',
  ws_acc_glue007_stand_desc: '43mm工業用グルーガン安定休止用ヘビーデューティー金属スタンド',
  ws_acc_glue007_tool_bag_name: '工業用ツールバッグ',
  ws_acc_glue007_tool_bag_desc: '大型グルーガン43mmカートリッジとノズル配件用ツールバッグ',

  // glue-008 配件（LEDスマート）
  ws_acc_glue008_sticks_name: 'グルースティック',
  ws_acc_glue008_sticks_desc: '11mmグルースティック50本入り、LEDインジケータースマートグルーガン用透明型',
  ws_acc_glue008_led_module_name: 'LEDインジケーターモジュール',
  ws_acc_glue008_led_module_desc: 'スマートグルーガンLEDレディインジケーターランプ回路板交換モジュール',
  ws_acc_glue008_nozzle_set_name: 'ノズルセット',
  ws_acc_glue008_nozzle_set_desc: 'LEDインジケーターグルーガン用標準/細先/広先3種ノズルセット',
  ws_acc_glue008_gauge_name: 'キャリブレーションツール',
  ws_acc_glue008_gauge_desc: 'スマートグルーガンLEDレディインジケーターキャリブレーション検査ツール',
  ws_acc_glue008_mat_name: 'シリコンワークマット',
  ws_acc_glue008_mat_desc: 'スマートLEDグルーガン作業用耐熱シリコンワーク表面マット',
  ws_acc_glue008_cleaning_brush_name: 'クリーニングブラシセット',
  ws_acc_glue008_cleaning_brush_desc: 'スマートグルーガンノズルとバレルメンテナンスクリーニングブラシセット',
  ws_acc_glue008_stand_name: 'スマート休止スタンド',
  ws_acc_glue008_stand_desc: 'LEDインジケーターホットグルーガン用金属サポートスタンド',
  ws_acc_glue008_manual_name: 'ユーザーマニュアル',
  ws_acc_glue008_manual_desc: 'スマートLEDグルーガンインジケーターランプ状態ガイドと操作マニュアル',

  // glue-009 配件（デュアルノズル）
  ws_acc_glue009_nozzle_kit_name: '交換ノズルキット',
  ws_acc_glue009_nozzle_kit_desc: 'デュアルノズルガン用異形8種交換ノズルキット',
  ws_acc_glue009_sticks_name: 'カラフルスティックセット',
  ws_acc_glue009_sticks_desc: 'デュアルノズルクラフトグルーガン用カラフル11mmホットグルースティックセット',
  ws_acc_glue009_switch_tool_name: 'ノズル交換ツール',
  ws_acc_glue009_switch_tool_desc: 'デュアルノズルガン用ノズル安全着脱レンチツール',
  ws_acc_glue009_caps_name: 'シールキャップ',
  ws_acc_glue009_caps_desc: 'デュアルノズルグルーガンアイドルポート用シール収納プラグキャップ',
  ws_acc_glue009_mat_name: 'デュアルゾーンマット',
  ws_acc_glue009_mat_desc: 'デュアルノズルグルーガンプロジェクト用デュアルゾーン耐熱シリコンワークマット',
  ws_acc_glue009_anti_drip_name: '防滴ガード',
  ws_acc_glue009_anti_drip_desc: 'デュアルノズルガンからのグルー滴り防止用防滴ガード',
  ws_acc_glue009_rack_name: 'ノズル収納ラック',
  ws_acc_glue009_rack_desc: 'デュアルノズルグルーガン用8スロット壁掛けノズル収納ラック',
  ws_acc_glue009_manual_name: 'ユーザーマニュアル',
  ws_acc_glue009_manual_desc: 'デュアルノズルグルーガンノズルチャートと応用ガイドマニュアル',

  // glue-010 配件（長バレル）
  ws_acc_glue010_sticks_name: 'グルースティック',
  ws_acc_glue010_sticks_desc: '11mmグルースティック40本入り、長バレルガン汎用型',
  ws_acc_glue010_ext_nozzle_tips_name: '延長ノズルチップセット',
  ws_acc_glue010_ext_nozzle_tips_desc: '長バレルグルーガン用異長延長ノズルチップセット',
  ws_acc_glue010_adapter_name: 'ノズル延長アダプター',
  ws_acc_glue010_adapter_desc: '長リーチグルーガンへの追加長さ用ノズル延長アダプター',
  ws_acc_glue010_deep_reach_name: 'ディープリーチアプリケーター',
  ws_acc_glue010_deep_reach_desc: '深部窪みや狭い場所でのグルーイング用曲がり柔軟ディープリーチアプリケーター',
  ws_acc_glue010_mat_name: 'シリコンワークマット',
  ws_acc_glue010_mat_desc: '延長ノズルグルーガンプロジェクト用耐熱シリコンワークマット',
  ws_acc_glue010_sleeve_name: '耐熱シリコンスリーブ',
  ws_acc_glue010_sleeve_desc: '長バレル偶発接触防止用耐熱シリコン保護スリーブ',
  ws_acc_glue010_stand_name: 'トールスタンド',
  ws_acc_glue010_stand_desc: '長バレルホットグルーガン用高脚昇降サポートスタンド',
  ws_acc_glue010_case_name: 'ロングストレージケース',
  ws_acc_glue010_case_desc: '長ノズルフルレングスグルーガンツール収納用拡張収納ケース',
};

export default workshopFeaturesJa;
